import { Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { UserRights } from '../../../../services/user-service/user-rights.enum';
import { UserService } from '../../../../services/user-service/user.service';

@Component({
  selector: 'app-delete-cell-renderer',
  templateUrl: './delete-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
})
export class DeleteCellRendererComponent implements ICellRendererAngularComp {
  private readonly userService = inject(UserService);

  private params: any;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  public onDelete($event: any): void {
    if (this.params.onDelete instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onDelete(params);
    }
  }

  public isDeletable(): boolean {
    return this.userService.hasRight(UserRights.CAMPAIGNS_WORKFLOW) && !this.params.isCampaignState8or9;
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
